.wrapper {
  align-items: center;
  #addTagButton {
    .ds-icon-add {
      position: absolute;
      left: 5px;
      font-size: 20px;
    }
    #addTagButtonText {
      font-size: var(--body-size);
      padding-left: calc(var(--spacer) * 3);
    }
  }
}
